module.exports = __webpack_public_path__ + "assets/img/onboarding_2.de99ff2f.png";